import React, { Suspense, lazy, useState } from "react";
import "./default.css";
import { IoMenuSharp } from "react-icons/io5";
import { FaVideo } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { useTranslation } from "react-i18next";
import footerLogo from "../../assets/images/footerLogo.png";

const HeaderMenu = lazy(() => import("./HeaderMenu"));

const Header = () => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [closing, setClosing] = useState(false);

  const handleCloseMenu = () => {
    setClosing(true);
    setTimeout(() => {
      setMenuOpen(false);
      setClosing(false);
    }, 500);
  };

  return (
    <>
      <div
        className={`h-16 p-3 flex justify-between items-center shadow-lg ${
          menuOpen && "bg-primary relative z-10"
        }`}
      >
        <div
          className={`h-[36px] w-[36px] ${
            menuOpen ? "text-white" : "text-primary"
          } rounded-[100%] items-center flex justify-center`}
        >
          {menuOpen ? (
            <img className="fade-in w-auto" src={footerLogo} alt="" />
          ) : (
            <div className="text-primary">
              <FaVideo size={20} />
            </div>
          )}
        </div>
        {menuOpen ? (
          <div
            className={`fade-in w-auto text-[16px] font-semibold text-white`}
          >
            {t("storiesForLife")}
          </div>
        ) : (
          <div className={`w-auto text-[16px] font-semibold text-primary`}>
            {t("storiesForLife")}
          </div>
        )}
        {menuOpen ? (
          <div
            onClick={handleCloseMenu}
            className="w-[36px] h-[36px] rounded-full bg-white p-1.5 text-primary cursor-pointer"
          >
            <RxCross2 size={24} />
          </div>
        ) : (
          <div
            onClick={() => setMenuOpen(true)}
            className="h-[36px] w-[36px] bg-primary text-white rounded-[100%] items-center flex justify-center cursor-pointer"
          >
            <IoMenuSharp size={20} />
          </div>
        )}
      </div>

      {menuOpen && (
        <Suspense fallback={null}>
          <HeaderMenu closing={closing} />
        </Suspense>
      )}
    </>
  );
};

export default Header;
